import eventTypes from './event-types';

/**
 * @property {number} leasingOfferIndex
 * @property {string} leasingOfferTitle
 * @property {LeasingOfferFeatures} leasingOfferFeatures
 */
export class LeasingOfferDataEvent extends Event {
  /**
   * @param {number} leasingOfferIndex
   * @param {string} leasingOfferTitle
   * @param {LeasingOfferFeatures} leasingOfferFeatures
   * @param {EventInit} [eventInit={}]
   */
  constructor(leasingOfferIndex, leasingOfferTitle, leasingOfferFeatures, eventInit = {}) {
    super(eventTypes.leasingOfferData, { bubbles: true, ...eventInit });
    this.leasingOfferIndex = leasingOfferIndex;
    this.leasingOfferTitle = leasingOfferTitle;
    this.leasingOfferFeatures = leasingOfferFeatures;
  }
}
